/**
 * Mock profile data for website-preview (Economy, Premium, Elite).
 * Used when real profile is not available.
 */

import type { Profile } from "@/types/types";

export const mockData: Profile = {
  artist: {
    slug: "tom-cruise",
    name: "Tom Cruise",
    profile_pic:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  },
};
